import clsx from 'clsx';
import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';
import styles from './Chip.module.css';

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  /** Small count bubble after the label. */
  count?: ReactNode;
}

/** 42 px filter chip (`.chip`). Selected inverts. */
export function Chip({ selected = false, count, className, children, type = 'button', ...rest }: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={clsx(styles.chip, selected && styles.on, className)}
      {...rest}
    >
      {children}
      {count !== undefined && <span className={styles.count}>{count}</span>}
    </button>
  );
}

/** Horizontal, scrollbar-less chip row. `wrap` lets chips wrap instead of scrolling. */
export function ChipGroup({ wrap = false, className, ...rest }: HTMLAttributes<HTMLDivElement> & { wrap?: boolean }) {
  return <div className={clsx(styles.chips, wrap && styles.wrap, className)} {...rest} />;
}
